/**
 * Stati di verifica dell'unicità del nome prodotto
 */
export const UNIQUENESS_STATUS = {
    IDLE: null,
    CHECKING: 'checking',
    UNIQUE: 'unique',
    NOT_UNIQUE: 'not-unique',
};

export default UNIQUENESS_STATUS;
